import { z } from 'zod';
import { roleSummarySchema } from '../user/types';

/**
 * Invitation response schema.
 */
export const invitationResponseSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  email: z.string().email(),
  roleIds: z.array(z.string().uuid()),
  roles: z.array(roleSummarySchema).nullable().optional(),
  token: z.string(),
  expiresAt: z.string().datetime(),
  acceptedAt: z.string().datetime().nullable(),
  invitedBy: z.string().uuid().nullable(),
  createdAt: z.string().datetime().nullable(),
});

export type InvitationResponse = z.infer<typeof invitationResponseSchema>;

/**
 * Invitation list response schema — omits token to prevent leakage in list views.
 */
export const invitationListResponseSchema = invitationResponseSchema.omit({ token: true });

export type InvitationListResponse = z.infer<typeof invitationListResponseSchema>;

/**
 * Create invitation request schema.
 */
export const createInvitationSchema = z.object({
  email: z.string().email('Invalid email format'),
  roleIds: z.array(z.string().uuid()).min(1, 'At least one role is required'),
});

export type CreateInvitationRequest = z.infer<typeof createInvitationSchema>;
